'use client';

import Image from 'next/image';
import s from './styles.module.scss';
import FancyButton from '@/src/components/ui/FancyButton';
import React, { useEffect, useState } from 'react';
import { useModal } from '@/src/components/ui/ModalProvider';
import { useViewport } from '@/src/lib/useViewport';

const BP = 786;

export const Survive = () => {
    const { openModal } = useModal();
    const { mounted, vw, isMobile } = useViewport(BP);

    if (!mounted || vw === null) {
        return <div className={s.root} />;
    }
    return (
        <div className={s.root}>
            {isMobile ? (
                <div className={s.desctop_block_mob}>
                    <h2>Проживи тиждень на максимум:</h2>
                    <div>

                        {isMobile ? (
                            <FancyButton
                                normalSvg="/icons/btn_want.svg"
                                hoverSvg="/icons/btn_want_active.svg"
                                width={153}
                                height={44}
                                fit="fill"
                                className={s.btn}
                                onClick={openModal}
                            />
                        ):(
                            <FancyButton
                                normalSvg="/icons/btn_want.svg"
                                hoverSvg="/icons/btn_want_active.svg"
                                width={173}
                                height={78.4}
                                fit="fill"
                                className={s.btn}
                                onClick={openModal}
                            />
                        )}

                        <Image
                            src="/images/survive.png"
                            alt=""
                            width={196.77272033691406}
                            height={127.35783386230469}
                            priority
                        />
                    </div>
                </div>
            ) : (
                <div className={s.desctop_block}>
                    <div className={s.desctop}>
                        <h2>Забронюйте тиждень трансформації</h2>
                        <FancyButton
                            normalSvg="/icons/btn_want.svg"
                            hoverSvg="/icons/btn_want_active.svg"
                            width={253}
                            height={83}
                            fit="fill"
                            className={s.btn}
                            onClick={openModal}
                        />
                    </div>

                    <Image
                        src="/images/survive.png"
                        alt=""
                        width={354}
                        height={229}
                        priority
                    />
                </div>
            )}
        </div>

    );
};
